export const articleStyles = {
    display: 'flex',
    marginBottom: 20,
    boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)',
    backgroundColor: '#fff',
    padding: '20px 10px',
    gap: '.5vw',
    animation: 'transitionIn .75s'
}

export const likesSectionStyles = {
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '2%',
    justifyContent: 'flex-start',
    alignItems: 'center'
}

export const articleSection = {
    flexBasis: '90%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
}

export const detailsStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 20,
    fontSize: '.8rem'
}

export const arrowsStyles = {
    width: '55%', 
    cursor: 'pointer',
}